import SearchBox from './searchBox.js';

export default SearchBox;